<template>
  <section class="data-cues-chart">      
      <h2 v-if="chartData.cardTitle" class="data-cues-chart__title">{{ chartData.cardTitle }}</h2>
   
      <div v-if="chartData.cardImage?.src" class="data-cues-chart__image">
        <img :src="chartData.cardImage.src" :alt="chartData.cardImage.alt" />
      </div>

      <div class="data-cues-chart__mobile">  

        <div v-if="chartData.cardSubTitle || chartData.cardDescription" class="chart-section__text">
          <h3 v-if="chartData.cardSubTitle" class="chart-section__subtitle">{{ chartData.cardSubTitle }}</h3>
          <p v-if="chartData.cardDescription" class="chart-section__description">{{ chartData.cardDescription }}</p>
        </div>

        <DataCuesCard 
          v-if="normalizedStats.length > 0"
          :stats="normalizedStats"
          class="chart-section__card"
        />

        <h2 v-if="chartData.statImageTitle" class="chart-section__image-title">{{ chartData.statImageTitle }}</h2>

        <div v-if="chartData.statGraphImage?.src" class="chart-section__image-content">
          <img :src="chartData.statGraphImage.src" :alt="chartData.alt" />
        </div>      
      </div>
    
      <div class="data-cues-chart__desktop">        
        <div v-if="chartData.statImageTitle || chartData.statGraphImage || chartData.cardSubTitle || chartData.cardDescription" class="chart-section">
          <!-- Chart image section on left -->
          <div v-if="chartData.statGraphImage || chartData.statImageTitle" class="chart-section__image">
            <h2 v-if="chartData.statImageTitle" class="chart-section__image-title">{{ chartData.statImageTitle }}</h2>
            <div v-if="chartData.statGraphImage?.src" class="chart-section__image-content">              
              <img :src="chartData.statGraphImage.src" :alt="chartData.alt" />
            </div>
          </div>

          <!-- Content wrapper for desktop (right side) -->
          <div v-if="chartData.cardSubTitle || chartData.cardDescription || normalizedStats.length > 0" class="chart-section__content">
            <DataCuesCard 
              v-if="normalizedStats.length > 0"
              :stats="normalizedStats"
            />
            
            <div v-if="chartData.cardSubTitle || chartData.cardDescription" class="chart-section__text">
              <h3 v-if="chartData.cardSubTitle" class="chart-section__subtitle">{{ chartData.cardSubTitle }}</h3>
              <p v-if="chartData.cardDescription" class="chart-section__description">{{ chartData.cardDescription }}</p>
            </div>
          </div>
        </div>
      </div>    
     
      <DataCuesFooter 
        :sources="chartData.sources" 
        :links="chartData.links" 
        :footNoteText="chartData.footNoteText" 
        :learnMoreText="chartData.learnMoreText" 
        :learnMoreLink="chartData.learnMoreLink" 
        :isExternalLink="chartData.isExternalLink" 
        :learnMoreTaggingAttributes="chartData.learnMoreTaggingAttributes" 
      />
  </section>
</template>

<script>
import DataCuesCard from './DataCuesCard.vue'
import DataCuesFooter from './DataCuesFooter.vue'

export default {
  name: 'DataCuesChart',
  components: {
    DataCuesCard,
    DataCuesFooter
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    normalizedStats() { 
      if (this.chartData.statValue || this.chartData.statDescription) {
        return [{
          statValue: this.chartData.statValue,
          statDescription: this.chartData.statDescription,
          comparisonText: this.chartData.statComparisionText || this.chartData.comparisonText
        }];
      }
      
      return [];
    }
  }
}
</script>
<style lang="scss" src="./DataCuesChart.scss"></style>

